import { apiUrl, execUrl } from 'libs/commonVar';
import * as common from 'libs/commonFunc';

export const getEduAPI = params => common.requestRaw(apiUrl + 'Edu', params, 'get');
export const getEduExamAPI = params => common.requestRaw(apiUrl + 'Exam', params, 'get');
export const getEduTargetAPI = params => common.requestRaw(apiUrl + 'Edu/Target', params, 'get');
export const getEduAttachAPI = params => common.requestRaw(apiUrl + 'Edu/EduAttach', params, 'get');
export const getEduTagAPI = params => common.requestRaw(apiUrl + 'Tag', params, 'get');
export const postEduAPI = params => common.requestRaw(apiUrl + 'Edu', params, 'post');
export const putEduAPI = params => common.requestRaw(apiUrl + 'Edu', params, 'put');
export const deleteEduAPI = params => common.requestRaw(apiUrl + 'Edu', params, 'delete');

export const getEduHistoryAPI = params => common.requestRaw(apiUrl + 'Edu/EduHistory', params, 'get');

// 교육 템플릿
export const getEduTemplateAPI = params => common.requestRaw(apiUrl + 'EduTemplate', params, 'get');
export const addEduTemplateAPI = params => common.requestRaw(apiUrl + 'EduTemplate', params, 'post');
export const deleteEduTemplateAPI = params => common.requestRaw(apiUrl + 'EduTemplate', params, 'delete');

// 교육하기 퀴즈 페이지
export const getEduQuizAPI = params => common.requestRaw(apiUrl + 'Quiz', params, 'get');
export const postEduQuizAPI = params => common.requestRaw(apiUrl + 'Quiz', params, 'post');
export const putEduQuizAPI = params => common.requestRaw(apiUrl + 'Quiz', params, 'put');
export const deleteEduQuizAPI = params => common.requestRaw(apiUrl + 'Quiz', params, 'delete');

// 교육 실시 모달
export const getEduModalQuizAPI = params => common.requestRaw(apiUrl + 'Quiz/QuizList', params, 'get');



// WEBPACK FOOTER //
// ./src/script/libs/eduLib.js